import React from "react";
import { useLocationStore } from "./hooks/useLocationStore";
import "./assets/style/Contact.css";

const Contact = () => {
  const selectedLocation = useLocationStore((state) => {
    const { mainLocations, selectedLocationId } = state;
    return mainLocations.find((l) => l.id === selectedLocationId) || null;
  });

  // Use selected main location data if available, otherwise fall back to env vars
  const address = selectedLocation?.address || process.env.REACT_APP_CONTACT_ADDRESS;
  const googleMapsLink = selectedLocation?.google_maps_embed || process.env.REACT_APP_CONTACT_GOOGLE_MAPS_LINK;

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Kontakt</h2>
        </div>

        <div className="row">
          <div className="col-lg-12 d-flex align-items-stretch">
            <div className="info">
              <div className="container">
                <div className="row">
                  <div className="address col-lg-4 col-md-6">
                    <i className="bi bi-geo-alt"></i>
                    <h4>Wpadnij:</h4>
                    <p>{address}</p>
                  </div>
                  <div className="phone col-lg-4 col-md-6">
                    <i className="bi bi-phone"></i>
                    <h4>Zadzwoń:</h4>
                    <p>{process.env.REACT_APP_CONTACT_PHONE1}</p>
                  </div>

                  <div className="email col-lg-4 col-md-6">
                    <i className="bi bi-envelope"></i>
                    <h4>Napisz:</h4>
                    <p>{process.env.REACT_APP_CONTACT_EMAIL}</p>
                  </div>
                </div>
              </div>
              {googleMapsLink && (
                <iframe
                  src={googleMapsLink}
                  frameBorder="0"
                  style={{ border: 0, width: "100%", height: "290px" }}
                  allowFullScreen
                  title="Google Maps"
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
